import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationResponse } from '@edtech-ui/core/models/notifications/get-notification-response';
import { TeacherNotificationResponse } from '@edtech-ui/core/models/notifications/get-teacher-notifications';
import { MarkNotificationPayload, MarkNotificationReadResponse } from '@edtech-ui/core/models/notifications/marked-notification-response';
import { MarkTeacherNotificationPayload, MarkTeacherNotificationReadResponse } from '@edtech-ui/core/models/notifications/marked-teacher-notifications';
import { environment } from 'environments/environment';
import { Observable, Subject, tap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	apiUrl = environment.notificationApiUrl;
		reload$ = new Subject<void>;

	constructor(private readonly http: HttpClient) { }

	getNotificationsForStudent(notificationLimit: number=20): Observable<NotificationResponse> {
		const params = new HttpParams().set('limit', notificationLimit)
		return this.http.get<NotificationResponse>(`${this.apiUrl}/getUnreadNotifications`, { params });
	}

	putMarkedNotifications(payload:MarkNotificationPayload):Observable<MarkNotificationReadResponse>{
		const params = this.buildNotificationParams(payload.notification_ids)
		return this.http.put<MarkNotificationReadResponse>(`${this.apiUrl}/markAsRead`, null, { params }).pipe(
			tap(() => this.reload$.next())
		);
	}

	deleteNotification(notificationId:string):Observable<any>{
		return this.http.delete<any>(`${this.apiUrl}/deleteNotification/${notificationId}`);
	}

	getNotificationsForTeachers(notificationLimit: number = 20): Observable<TeacherNotificationResponse> {
		const params = new HttpParams().set('limit', notificationLimit)
		return this.http.get<TeacherNotificationResponse>(`${this.apiUrl}/TeacherUnreadNotifications`, { params })
	}

	putMarkedTeacherNotifications(payload: MarkTeacherNotificationPayload): Observable<MarkTeacherNotificationReadResponse> {
		const params = this.buildNotificationParams(payload.notification_ids)
		return this.http.put<MarkTeacherNotificationReadResponse>(`${this.apiUrl}/markAsReadTeacher`, null, { params }).pipe(
			tap(() => this.reload$.next()));
	}

	deleteNotificationTeacher(notificationId: string): Observable<any> {
		return this.http.delete<any>(`${this.apiUrl}/deleteNotificationTeacher/${notificationId}`);
	}

	private buildNotificationParams(ids: string[]): HttpParams {
		let params = new HttpParams();
		ids.forEach(id => {
			params = params.append('notification_ids', id);
		});
		return params;
}
}
